// removed by extract-text-webpack-plugin


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/Newsfeeds/style.css
 ** module id = 843
 ** module chunks = 0
 **/